/* eslint-disable react/no-danger */

import React from 'react';
import { useSelector } from 'react-redux';

import {
	useIsBelowSmallOnly,
	useIsSmallAndAbove,
} from '../../../hooks/mediaQueries';
import {
	convertStringToValidHtml,
	isBrowserIE11,
} from '../../../utilities/lister-utilities';
import BrandedBanner from '../BrandedBanner/BrandedBanner';
import DynamicBanner from '../DynamicBanner/DynamicBanner';
import InsecureBanner from './InsecureBanner';
import JsonBanner from './JsonBanner';

export const TopBanner = () => {
	const {
		categoryId,
		seoHtml: { MobileTop, DesktopTop } = {},
		banners: { Top } = {},
		facets,
		canonical,
	} = useSelector((state) => state);

	const { BrandedDrawerEnabled } = useSelector(
		(state) => state.featureSwitches
	);

	const isBelowSmallOnly = useIsBelowSmallOnly();
	const isSmallAndAbove = useIsSmallAndAbove();

	const isIE11 = isBrowserIE11();

	const getBannerConfig = (banner) => {
		let bannerConfig;
		const convertedHtml = convertStringToValidHtml(banner);

		try {
			bannerConfig = JSON.parse(convertedHtml);
		} catch (error) {
			throw new Error('Error parsing banner config, check config is valid.');
		}

		if (!bannerConfig) {
			return null;
		}

		return bannerConfig[categoryId];
	};

	//
	//
	// Brand drawer banners
	//
	//
	if (!isIE11 && BrandedDrawerEnabled) {
		const brands = facets?.find(({ Id }) => Id === 'brandname');

		const nonSelected = Boolean(
			brands?.FacetValues?.every(({ Selected }) => !Selected)
		);

		if (canonical?.includes('lg') || nonSelected) {
			const bannerCategories = ['washing_machines', 'washer_dryers'];

			const isOnBannerPage = Boolean(
				bannerCategories.find((cat) => canonical?.includes(cat))
			);

			if (isOnBannerPage) {
				return <BrandedBanner />;
			}
		}
	}

	// Dynamic Banners
	if (Top?.length > 0) {
		return <DynamicBanner {...Top[0]} />;
	}

	if (!MobileTop && !DesktopTop) {
		return null;
	}

	if (isBelowSmallOnly && MobileTop?.includes('text/css')) {
		return (
			<InsecureBanner
				classes="text-center pb-4"
				testId="top-banner-small"
				banner={MobileTop}
			/>
		);
	} else if (isSmallAndAbove && DesktopTop?.includes('text/css')) {
		return (
			<InsecureBanner
				classes="text-center pb-4"
				testId="top-banner-large"
				banner={DesktopTop}
			/>
		);
	}

	let configToUse;

	if (isBelowSmallOnly && MobileTop) {
		configToUse = MobileTop;
	} else if (isSmallAndAbove && DesktopTop) {
		configToUse = DesktopTop;
	}

	const bannerConfig = getBannerConfig(configToUse);

	if (!bannerConfig) {
		return null;
	}

	return <JsonBanner {...bannerConfig} />;
};

export default TopBanner;
